import React, { useState, useEffect } from "react";
import logo from "../../../assets/images/logo-white.png";
import { Input, Modal, notification } from "antd";
import { GET } from "../../../utils/apiRequest";
import { LoadingOutlined } from "@ant-design/icons";
import { IoMdSearch } from "react-icons/io";
import { AiOutlineScan } from "react-icons/ai";
import { Html5QrcodeScanner } from "html5-qrcode";
import "../styles.scss";

function Card(props: any) {
  const [cardNo, setCardNo] = useState("");

  const qrCodeSuccessCallback = (decodedText: any) => {
    setCardNo(decodedText);
    props?.handleSearch(decodedText);
  };

  const qrCodeErrorCallback = (errorMessage: any) => {
    console.error("Error scanning QR code:", errorMessage);
  };

  const handleOk = () => {
    props?.setVisible(false);
  };

  const handleCancel = () => {
    props?.setVisible(false);
  };
  useEffect(() => {
    if (props?.visible) {
      const html5QrcodeScanner = new Html5QrcodeScanner(
        "html5qr-code-full-region",
        {
          fps: 10,
          qrbox: 250,
          aspectRatio: 1,
          disableFlip: false,
        },
        true
      );
      html5QrcodeScanner.render(qrCodeSuccessCallback, qrCodeErrorCallback);
      return () => {
        html5QrcodeScanner.clear().catch((error: any) => {
          console.error("Failed to clear html5QrcodeScanner. ", error);
        });
      };
    }
  }, [props?.visible]);
  return (
    <>
      <div className="Share-cardBox">
        <div className="Share-cardInnerBox">
          <div className="Share-cardtxt1">LOYALTY CARD</div>
          <div style={{ padding: 7 }}>
            <img className="Share-cardLogo" src={logo} alt="Logo" />
          </div>
        </div>
        <div className="Share-cardtxt2">{props?.fullDetails?.card?.cardNo}</div>
        {props?.fullDetails?.card ? (
          <div className="Share-cardtxt5 mt-2">{props?.fullDetails?.card?.name}</div>
        ) : props?.error ? (
          <div className="Share-cardtxt7">Card Not Assigned</div>
        ) : (
          <div />
        )}
        <div className="Share-cardInnerBox">
          <div style={{ display: "flex", alignItems: "end", gap: 5 }}>
            <div style={{ display: "flex", width: "75%" }}>
              <Input
                placeholder="Enter cardNo"
                className="Share-searchInput"
                value={cardNo}
                onChange={(e) => setCardNo(e.target.value)}
                onPressEnter={() => props?.handleSearch(cardNo)}
              />
              <div
                className="Share-searchIcon"
                onClick={() => props?.handleSearch(cardNo)}
              >
                {props?.isLoading ? (
                  <LoadingOutlined style={{ fontSize: 20 }} spin />
                ) : (
                  <IoMdSearch size={20} color="white" />
                )}
              </div>
            </div>
            <AiOutlineScan
              size={33}
              color="#08493e"
              onClick={() => props?.setVisible(true)}
            />
          </div>
          {props?.fullDetails?.card?.balance ? 
          <div>
            <div className="Share-cardtxt3">Balance</div>
            <div className="Share-cardtxt4">₹{props?.fullDetails?.card?.balance}</div>
          </div> : null}
        </div>
      </div>
      {props?.visible ? (
        <Modal
          title="Scan QR Code"
          open={props?.visible}
          onOk={handleOk}
          footer={false}
          onCancel={handleCancel}
        >
          <div id="html5qr-code-full-region" style={{ width: "100%" }} />
        </Modal>
      ) : null}
    </>
  );
}

export default Card;
